import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { API_BASE } from "../config";

export default function EndAbonnement() {
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState(null);

  console.log("PAGE LOADED ✅");
console.log("URL =", window.location.href);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("error");
      setMessage("Session de paiement introuvable dans l’URL.");
      return;
    }

    (async () => {
      try {
        //https://cloterenotaire.onrender.com/api/end-abonnement
        //const res = await fetch(`http://localhost:5050/api/end-abonnement?session_id=${encodeURIComponent(sessionId)}`, {

        // ⚠️ adapte l’URL à ton backend (ex: /api/stripe/confirm-subscription)
        const res = await fetch(`${API_BASE}/api/end-abonnement?session_id=${encodeURIComponent(sessionId)}`, {
          method: "GET",
          headers: { "Accept": "application/json" },
          credentials: "include", // garde si tu utilises des cookies auth
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          setStatus("error");
          setMessage(data?.error || "Impossible de confirmer l’abonnement.");
          return;
        }

        setDetails(data);
        setStatus("success");
        setMessage(data?.message || "Votre abonnement est actif.");
      } catch (e) {
        setStatus("error");
        setMessage("Erreur réseau. Merci de réessayer.");
      }
    })();
  }, [location.search]);

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8 dark:bg-gray-900">
      <div className="text-center max-w-xl">
        {status === "loading" && (
          <>
            <p className="text-base font-semibold text-indigo-600 dark:text-indigo-400">
              Paiement en cours de validation…
            </p>
            <h1 className="mt-4 text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl dark:text-white">
              Finalisation de votre abonnement
            </h1>
            <p className="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 dark:text-gray-400">
              Merci de patienter, nous confirmons votre paiement.
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <p className="text-base font-semibold text-indigo-600 dark:text-indigo-400">
              C'est parfait !
            </p>
            <h1 className="mt-4 !text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-6xl dark:text-white">
              Votre abonnement est actif
            </h1>
            <p className="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 dark:text-gray-400">
              {message}
            </p>

            {/* Optionnel : afficher des IDs pour debug (retire en prod si tu veux) */}
            {details?.stripe_subscription_id && (
              <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
                Vous allez recevoir votre facture par mail.
              </p>
            )}

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/connexion"
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
              >
                Me connecter
              </Link>

            </div>
          </>
        )}

        {status === "error" && (
          <>
            <p className="text-base font-semibold text-indigo-600 dark:text-indigo-400">
              Oups
            </p>
            <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-6xl dark:text-white">
              Impossible de confirmer l’abonnement
            </h1>
            <p className="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 dark:text-gray-400">
              {message}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
             
              <a href="mailto:contact@clotere.fr" className="text-sm font-semibold text-gray-900 dark:text-white">
                Contacter le support <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </>
        )}
      </div>
    </main>
  );
}